import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {IDocument, IDocumentState, initialDocumentState} from "./Helper";
import {createDocument, getDocumentHistoryByName, getLatestDocumentByName, getLatestDocuments} from "./ActionCreators";

const initialValue: IDocumentState = {
    fetchLoading: false,
    items: [],
    item: initialDocumentState,
    actionLoading: false,
    fetchHistoryLoading: false,
    documentHistory: []
}

const documentSlice = createSlice({
    name: SliceNames.DOCUMENT,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getLatestDocuments.pending, (state) => {
                state.fetchLoading = true
            })
            .addCase(
                getLatestDocuments.fulfilled, (state, action: PayloadAction<IDocument[]>) => {
                    state.items = action.payload
                    state.fetchLoading = false
                })
            .addCase(
                getLatestDocuments.rejected, (state) => {
                    state.items = []
                    state.fetchLoading = false
                })
            .addCase(
                getLatestDocumentByName.pending, (state) => {
                    state.fetchLoading = true
                })
            .addCase(
                getLatestDocumentByName.fulfilled, (state, action: PayloadAction<IDocument>) => {
                    state.item = action.payload
                    state.fetchLoading = false
                })
            .addCase(
                getLatestDocumentByName.rejected, (state) => {
                    state.fetchLoading = false
                })
            .addCase(
                createDocument.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createDocument.fulfilled, (state, action: PayloadAction<IDocument>) => {
                    const index = state.items.findIndex(item => item.name === action.payload.name);

                    if (index !== -1) {
                        // Replace the existing document with the same name
                        state.items[index] = action.payload;
                    } else {
                        // Add the new document as it does not exist
                        state.items.push(action.payload);
                    }
                    state.actionLoading = false
                })
            .addCase(
                createDocument.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                getDocumentHistoryByName.pending, (state) => {
                    state.fetchHistoryLoading = true
                })
            .addCase(
                getDocumentHistoryByName.fulfilled, (state, action: PayloadAction<IDocument[]>) => {
                    state.documentHistory = action.payload
                    state.fetchHistoryLoading = false
                })
            .addCase(
                getDocumentHistoryByName.rejected, (state) => {
                    state.fetchHistoryLoading = false
                    state.documentHistory = []
                })
    }
})

export default documentSlice.reducer

